import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Label } from "../label";
export const Switch = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {string} [props.label]
 * @param {string} [props.name]
 * @param {boolean} [props.defaultChecked]
 * @param {boolean} [props.checked]
 * @param {boolean} [props.disabled]
 * @param {(isChecked: boolean) => any} [props.onChange]
 * @param {any} [props.className]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function TextInput({
  label,
  name,
  defaultChecked,
  checked,
  disabled = false,
  onChange,
  className
}, ref) {
  const [_checked, setChecked] = useState(defaultChecked);
  const switchClasses = classNames(["switch"], {
    disabled
  });
  const isChecked = typeof checked !== "undefined" ? checked : _checked;

  const onChangeHandler = () => {
    if (!disabled) {
      onChange && onChange(!isChecked);
      setChecked(!isChecked);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: `flex flex-col items-center ${className}`
  }, /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement("input", {
    className: switchClasses,
    type: "checkbox",
    name: name,
    onChange: onChangeHandler,
    checked: isChecked,
    ref: ref,
    disabled: disabled
  }));
});
Switch.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool
};